import React from 'react'

const usersRoutes = [
    {
        path: '/administracao/usuarios',
        exact: true,
        component: React.lazy(() => import('./usuarios/lista/Table')),
    },
    {
        path: '/administracao/usuarios/novo',
        exact: true,
        component: React.lazy(() => import('./usuarios/form/Form')),
    }, 
    {
        path: '/administracao/usuarios/visualizar',
        exact: true,
        component: React.lazy(() => import('./usuarios/visualizar/Form')),
    }, 
]

export default usersRoutes
